























































































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Typography } from '@/components/atoms';

type LabelValueVariant = 'normal' | 'small';
type ConfigRadioType = 'default' | 'custom';

@Component<ConfigRadio>({
  components: {
    Typography
  }
})
export default class ConfigRadio extends Vue {
  @Prop() readonly label!: string;
  @Prop({ default: '' }) readonly value?: string;
  @Prop({ default: '' }) readonly labelValue?: string;
  @Prop({ default: '' }) readonly labelDescription?: string;
  @Prop({ default: false }) readonly isActive?: boolean;
  @Prop({ default: 'default' }) readonly type?: ConfigRadioType;
  @Prop({ default: '80px' }) readonly width?: string;
  @Prop({ default: '80px' }) readonly height?: string;
  @Prop({ default: 'normal' }) readonly labelValueVariant?: LabelValueVariant;
  @Prop({ default: 'button' }) readonly tag?: string;
  @Prop({ default: 0 }) readonly inputMin?: number;
  @Prop({ default: 99 }) readonly inputMax?: number;

  inputIsFocused = false;
  containerIsHovered = false;
  key = 0;

  get styleByType() {
    const styleMap: Record<ConfigRadioType, any> = {
      default: {
        activeClass: 'config-radio--active',
        hoverClass: 'config-radio--hovered'
      },
      custom: {
        activeClass: 'config-radio--active-custom',
        hoverClass: 'config-radio--hovered-custom'
      }
    };

    if (!this.type || !styleMap[this.type]) {
      return styleMap.default;
    }

    return styleMap[this.type];
  }

  get labelFontWeight() {
    return this.isActive || (this.type === 'default' && this.containerIsHovered)
      ? 700
      : 500;
  }

  onlyNumber(val: any) {
    if (isNaN(Number(val.key))) {
      return val.preventDefault();
    }
  }

  handleInput(event: any) {
    let value = parseInt(event.target && event.target.value, 10);

    if (typeof this.inputMax === 'number') {
      if (value > this.inputMax) {
        // Rerender component to update input value to the max value
        this.key += 1;
      }

      value = Math.min(value, this.inputMax);
    }

    if (typeof this.inputMin === 'number') {
      if (value < this.inputMin) {
        // Rerender component to update input value to the min value
        this.key += 1;
      }

      value = Math.max(value, this.inputMin);
    }

    this.$emit('input', isNaN(value) ? '' : value);
  }

  handleMouseEnter() {
    this.containerIsHovered = true;
    this.$emit('mouseenter');
  }

  handleMouseLeave() {
    this.containerIsHovered = false;
    this.$emit('mouseleave');
  }

  handleFocus() {
    this.inputIsFocused = true;
    this.$emit('input-state-focus', true);
  }

  handleFocusOut() {
    this.inputIsFocused = false;
    this.$emit('input-state-focus', false);
  }
}
